const doc = [({"en":({"js":({"admin":({"navigations":({"show":({"navigation":"Navigation", "open_in_google_maps":"Open in Google Maps"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;